import { useNegocioStore } from '@renderer/store/useNegocioStore';
import { NoPudeHacerAlgo } from './ayuda/NoPudeHacerAlgo';
import { PanelChat } from './ayuda/PanelChat';
import { useSessionStore } from '@renderer/store/useSessionStore';
import { logoUrl } from '@renderer/utils/logoUrl';
import { KeyRound, LogOut, User } from 'lucide-react';
import { useState } from 'react';
import { CambiarPinForm } from '@renderer/components/forms/CambiarPinForm';
import { useNavigate } from 'react-router-dom';

export function BrandingHeader() {
  const negocio = useNegocioStore((s) => s.negocio);
  const sesion = useSessionStore((s) => s.sesion);
  const setSesion = useSessionStore((s) => s.setSesion);
  const navigate = useNavigate();
  /**
   * Sprint 64 — "Mi PIN", donde está su nombre.
   *
   * El formulario ya existía pero vivía en Configuración, que es del dueño: una cajera no
   * tenía ninguna ruta hasta él. Y sin rotación, el PIN que le asignó el dueño es una
   * contraseña compartida de por vida.
   */
  const [cambiandoPin, setCambiandoPin] = useState(false);

  const onLogout = async () => {
    await window.api.auth.logout();
    setSesion(null);
    navigate('/login');
  };

  return (
    <header className="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-3">
      <div className="flex items-center gap-3">
        {negocio?.logoPath ? (
          <img
            src={logoUrl(negocio.fechaModificacion ?? negocio.id)}
            alt={negocio.nombre}
            className="h-10 w-10 rounded object-contain"
          />
        ) : (
          <div className="flex h-10 w-10 items-center justify-center rounded bg-primary text-primary-fg font-bold">
            {negocio?.nombre?.[0]?.toUpperCase() ?? 'R'}
          </div>
        )}
        <div>
          <div className="font-semibold leading-none">{negocio?.nombre ?? 'RestaurantPOS'}</div>
          {negocio?.rfc && (
            <div className="text-xs text-slate-500">RFC: {negocio.rfc}</div>
          )}
        </div>
      </div>

      {sesion && (
        <div className="flex min-w-0 items-center gap-3">
          <div className="flex min-w-0 items-center gap-2 text-sm">
            <User className="h-4 w-4 shrink-0 text-slate-500" />
            <span className="font-medium truncate max-w-[130px]">{sesion.nombre}</span>
            <span className="shrink-0 rounded bg-slate-100 px-2 py-0.5 text-xs uppercase tracking-wide text-slate-600">
              {sesion.rol}
            </span>
          </div>
          <button
            onClick={() => setCambiandoPin(true)}
            className="btn-ghost"
            aria-label="Cambiar mi PIN"
            title="Cambiar mi PIN de acceso"
          >
            <KeyRound className="h-4 w-4" />
            <span className="hidden sm:inline">Mi PIN</span>
          </button>
          {/*
            Sprint 134 (Fase 1) — El canal de dudas, donde siempre se ve.

            Va en el encabezado y no en una pantalla concreta porque las dudas aparecen en
            cualquiera: *"esa no supe cómo hacerle"* llegó desde promociones, *"¿cómo corrijo?"*
            desde existencias. Un botón de ayuda que hay que ir a buscar no lo usa nadie a las
            siete de la tarde.
          */}
          <PanelChat />
          <NoPudeHacerAlgo />
          <button onClick={onLogout} className="btn-ghost" aria-label="Cerrar sesión">
            <LogOut className="h-4 w-4" />
            <span>Salir</span>
          </button>
        </div>
      )}

      {cambiandoPin && (
        <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 p-4 pt-16">
          <div className="w-full max-w-md">
            <CambiarPinForm />
            <button
              onClick={() => setCambiandoPin(false)}
              className="mt-3 w-full rounded-lg bg-white px-4 py-3 font-medium text-slate-700 shadow"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
